var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-segment" }, [
    _c("label", { attrs: { for: "password" } }, [_vm._v("Enter password*")]),
    _vm._v(" "),
    _c("div", { staticClass: "lib-input-and-extra-container" }, [
      _c("input", {
        attrs: {
          type: _vm.showPassword ? "text" : "password",
          name: "password",
          placeholder: "Enter password",
          id: "password",
          required: "",
          "data-msg-required": "Please enter your password.",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "lib-input-extra" }, [
        _c(
          "button",
          {
            staticClass: "visibility-button",
            attrs: { type: "button", tabindex: "-1" },
            on: {
              click: function ($event) {
                _vm.showPassword = !_vm.showPassword
              },
            },
          },
          [
            _c("i", {
              staticClass: "fa-regular",
              class: {
                "fa-eye": !_vm.showPassword,
                "fa-eye-slash": _vm.showPassword,
              },
            }),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }